import { MemberType, MissionVisibility } from '@wwf/sdk';

const defaultMissionVisibilityByMemberType: Record<
    MemberType,
    { close: MissionVisibility; open: MissionVisibility }
> = {
    VOLUNTEER: { close: 'VOLUNTEER_CLOSE', open: 'VOLUNTEER_OPEN' },
    MAIN_VOLUNTEER: {
        close: 'MAIN_VOLUNTEER_CLOSE',
        open: 'MAIN_VOLUNTEER_OPEN',
    },
    STAFF: { close: 'STAFF', open: 'STAFF' },
};

export function memberTypeToDefaultMissionVisibility(
    memberType: MemberType,
    open: boolean
): MissionVisibility {
    return defaultMissionVisibilityByMemberType[memberType][
        open ? 'open' : 'close'
    ];
}
